'use strict';

import api from '../../api';

export default {
  namespaced: true,
  state: {
    pools:     [],
    morePools: true
  },
  mutations: {
    addPools(state, pools) {
      state.pools = [...state.pools, ...pools.slice(0,5)];
      state.morePools = pools.length > 5;
    }
  },
  actions: {
    loadNextPage({state, commit}) {
      if (state.morePools) {
        // Ask for 1 more than we want, just to see if there are more
        api.Pool.index({params: {limit: 6, offset: state.pools.length, ended: true}})
          .then(pools => {
            commit('addPools', pools);
            pools.forEach(pool => commit('updateCachedPool', pool, {root: true}));
          });
      }
    }
  },
  getters: {
    pools(state) {
      return state.pools;
    },
    morePools(state) {
      return state.morePools;
    }
  }
};
